export class locationIdRequest{
    locationId:number;
    plantId:number;
    constructor(locationId:number,plantId:number){
        this.locationId = locationId
        this.plantId = plantId
    }
}